import React from "react";
import { Redirect, Route } from "react-router-dom";
import Auth from "../../services/authentication/";

const auth = new Auth();
class AuthRoute extends React.Component {
  state = {
    loading: true
  };

  componentDidMount() {
    auth.isAuthenticated().then(authenticated => {
      this.setState({
        loading: false,
        authenticated
      });
    });
  }

  render() {
    const { authenticated, loading } = this.state;
    const { render, ...props } = this.props;

    if (loading) {
      return null;
    }

    return (
      <Route
        {...props}
        render={() => {
          if (authenticated) {
            return render(props);
          } else {
            return <Redirect to="/login" />;
          }
        }}
      />
    );
  }
}

export default AuthRoute;
